import { render } from "./Landing.vue?vue&type=template&id=329f48c2"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=329f48c2&lang=scss"
script.render = render

export default script